import React, { useState, useEffect } from "react";
import {
  getInstructorwithStudentData,
  getInstructorwithStudentDataWithStatus,
  getStudentIdData,
  getStudentIdDataWithStatus,
} from "../../lib/taskmanageview";
//import { updateData } from "../../lib/taskm";
import { useAuth } from "../../_helper/Auth/AuthProvider";
//import { TaskEdit } from "../TaskManagement/TaskEdit";
//import AgendaTaskModal from "./AgendaTaskModal";
//import { ToastNotification } from "../Lessons/CourseReport/CourseReportComponents";
//import { ConfirmModal } from "../Common/ConfirmModal";

const Tasks = ({ slug, isStudentView = false }) => {
  const [ setTaskList] = useState([]);
  const { user } = useAuth();
//  const [, setNewAnswer] = useState();
  const [updated] = useState(false);
  const [updatedId] = useState(0);
 // const [collapseOpenClose, setCollapseOpenClose] = useState(false);
  const [tab, setTab] = useState(2); // 1 : All , 2 : Open ,  4 : Close
  const [ error,setError] = useState("");
  const [ loading,setLoading] = useState(true);
  const [isDarkMode, setIsDarkMode] = useState(false);
 // const [isModalOpen, setIsModalOpen] = useState(false);
 // const [ setEditingTask] = useState(null);
 // const [ setToastMessage] = useState("");
 // const [ setShowToast] = useState(false);
//  const [ setShowConfirmModal] = useState(false);
 // const [deleteId, setDeleteId] = useState(null);
/*
  const showToastMessage = (message) => {
    setToastMessage(message);
    setShowToast(true);
    setTimeout(() => setShowToast(false), 3000);
  };

  const handleDelete = (id) => {
    setDeleteId(id);
    setShowConfirmModal(true);
  };
*/
/*
  const confirmDelete = async () => {
    if (deleteId) {
      try {
        await deleteIdData(deleteId);
        getStudentData();
        showToastMessage("Task deleted successfully!");
      } catch (error) {
        console.error("Error deleting task:", error);
        setError("Failed to delete task");
      } finally {
        setDeleteId(null);
        setShowConfirmModal(false);
      }
    }
  };

  const collapseAll = () => {
    setCollapseOpenClose(!collapseOpenClose);
  };
*/
  async function getStudentData() {
    try {
      setLoading(true);
      setError("");
      let tasks;
      setTaskList([]);

      if (isStudentView) {
        // Student viewing their own tasks - get all tasks for this student
        if (tab === 1) {
          //All
          tasks = await getStudentIdData(slug);
        } else if (tab === 2) {
          //"Current"
          tasks = await getStudentIdDataWithStatus(slug, "Current");
        } else if (tab === 3) {
          //"Later"
          tasks = await getStudentIdDataWithStatus(slug, "Later");
        } else if (tab === 4) {
          //Closed
          tasks = await getStudentIdDataWithStatus(slug, "Closed");
        }
      } else {
        // Instructor viewing student tasks - filter by instructor
        if (tab === 1) {
          //All
          tasks = await getInstructorwithStudentData(user.id, slug);
        } else if (tab === 2) {
          //"Current"
          tasks = await getInstructorwithStudentDataWithStatus(
            user.id,
            slug,
            "Current"
          );
        } else if (tab === 3) {
          //"Later"
          tasks = await getInstructorwithStudentDataWithStatus(
            user.id,
            slug,
            "Later"
          );
        } else if (tab === 4) {
          //Closed
          tasks = await getInstructorwithStudentDataWithStatus(
            user.id,
            slug,
            "Closed"
          );
        }
      }

      setTaskList(tasks);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setError("Failed to load tasks");
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    error && setError("");
    loading && setLoading(true);
    // Update task list when task is updated
    if (updated && updatedId) {
      getStudentData();
    }
  }, [updated, updatedId]);

  useEffect(() => {
    getStudentData();
  }, [tab, user?.id, slug]);

  useEffect(() => {
    getStudentData();
    setTab(2);
  }, [user?.id, slug]);

  useEffect(() => {
    const checkDarkMode = () => {
      setIsDarkMode(document.body.classList.contains("dark-only"));
    };
    checkDarkMode();
    const observer = new MutationObserver(checkDarkMode);
    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ["class"],
    });
    return () => observer.disconnect();
  }, []);

  /*
  async function changeTaskStatus(Id, statusway) {
    try {
      await updateData({
        id: Id,
        statusway: statusway,
      });
      getStudentData();
      showToastMessage("Task status updated successfully!");
    } catch (error) {
      console.error("Error updating task status:", error);
      setError("Failed to update task status");
    }
  }

  const toggleTab = (id) => {
    setTab(id);
  };

  const handleEdit = (task) => {
    setEditingTask(task);
    setIsModalOpen(true);
  };

  const handleAddTask = () => {
    setEditingTask(null);
    setIsModalOpen(true);
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };
*/
/*
  const getStatusStyle = (statusway) => {
    if (statusway === "Current") {
      return isDarkMode
        ? {
            backgroundColor: "rgba(13, 110, 253, 0.2)",
            color: "#6ea8fe",
            borderColor: "rgba(13, 110, 253, 0.5)",
          }
        : {
            backgroundColor: "rgba(13, 110, 253, 0.1)",
            color: "#0d6efd",
            borderColor: "rgba(13, 110, 253, 0.3)",
          };
    } else if (statusway === "Later") {
      return isDarkMode
        ? {
            backgroundColor: "rgba(255, 193, 7, 0.2)",
            color: "#ffd54f",
            borderColor: "rgba(255, 193, 7, 0.5)",
          }
        : {
            backgroundColor: "rgba(255, 193, 7, 0.1)",
            color: "#ffc107",
            borderColor: "rgba(255, 193, 7, 0.3)",
          };
    } else if (statusway === "Closed") {
      return isDarkMode
        ? {
            backgroundColor: "rgba(108, 117, 125, 0.2)",
            color: "#adb5bd",
            borderColor: "rgba(108, 117, 125, 0.5)",
          }
        : {
            backgroundColor: "rgba(108, 117, 125, 0.1)",
            color: "#6c757d",
            borderColor: "rgba(108, 117, 125, 0.3)",
          };
    }
    return {};
  };
*/
  /*
  const tableStyle = {
    backgroundColor: isDarkMode ? "#262932" : "#fff",
    color: isDarkMode ? "rgba(255, 255, 255, 0.6)" : "inherit",
  };

  const selectStyle = (statusway) => ({
    ...getStatusStyle(statusway),
    backgroundColor: isDarkMode ? "#262932" : "#fff",
    color: isDarkMode ? "rgba(255, 255, 255, 0.6)" : "inherit",
  });
*/
  return (
    <div
      className="card mb-4 shadow-sm"
      style={{
        borderRadius: "8px",
        backgroundColor: isDarkMode ? "#262932" : "#fff",
      }}
    >
{/*}
      <ToastNotification show={showToast} message={toastMessage} onClose={() => setShowToast(false)} />
      <div
        className="card-header border-bottom d-flex justify-content-between align-items-center"
        style={{ backgroundColor: isDarkMode ? "#262932" : "#fff" }}
      >
        <div className="d-flex align-items-center">
          <button
            type="button"
            className="btn btn-link p-0 me-2"
            data-bs-toggle="collapse"
            data-bs-target="#collapseAgenda"
            aria-expanded="false"
            aria-controls="collapseAgenda"
          >
            <i className="fa fa-chevron-down"></i>
          </button>
          <h5
            className="mb-0"
            style={{
              color: isDarkMode ? "rgba(255, 255, 255, 0.6)" : "inherit",
            }}
          >
            Agenda Management
          </h5>
        </div>
        <div></div>
      </div>
      <div className="collapse" id="collapseAgenda">
        <div
          className="card-body"
          style={{ backgroundColor: isDarkMode ? "#262932" : "#fff" }}
        >
          {error && (
            <div
              className="alert alert-danger alert-dismissible fade show"
              role="alert"
            >
              <strong>Error:</strong> {error}
              <button
                type="button"
                className="btn-close"
                onClick={() => setError("")}
                aria-label="Close"
              ></button>
            </div>
          )}

          <div className="d-flex justify-content-between align-items-center mb-3">
            {!isStudentView && (
              <button
                onClick={handleAddTask}
                className="btn btn-primary btn-sm"
              >
                <i className="fa fa-plus me-1"></i>
                Add Item to Student
              </button>
            )}
            {isStudentView && <div></div>}
            <button
              className="btn btn-outline-secondary btn-sm"
              onClick={() => collapseAll()}
            >
              <i className="fa fa-chevron-down me-1"></i>
              Collapse All
            </button>
          </div>

          {/* Navigation Tabs */} {/* 
          <div className="mb-3">
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <Link
                  className={`nav-link ${tab === 1 ? "active" : ""}`}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTab(1);
                  }}
                  style={{
                    color:
                      isDarkMode
                        ? tab === 1
                          ? "#fff"
                          : "rgba(255, 255, 255, 0.6)"
                        : "inherit",
                    cursor: "pointer",
                  }}
                >
                  All
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${tab === 2 ? "active" : ""}`}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTab(2);
                  }}
                  style={{
                    color:
                      isDarkMode
                        ? tab === 2
                          ? "#fff"
                          : "rgba(255, 255, 255, 0.6)"
                        : "inherit",
                    cursor: "pointer",
                  }}
                >
                  Agenda-1
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${tab === 3 ? "active" : ""}`}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTab(3);
                  }}
                  style={{
                    color:
                      isDarkMode
                        ? tab === 3
                          ? "#fff"
                          : "rgba(255, 255, 255, 0.6)"
                        : "inherit",
                    cursor: "pointer",
                  }}
                >
                  Agenda-2
                </Link>
              </li>
              <li className="nav-item">
                <Link
                  className={`nav-link ${tab === 4 ? "active" : ""}`}
                  onClick={(e) => {
                    e.preventDefault();
                    toggleTab(4);
                  }}
                  style={{
                    color:
                      isDarkMode
                        ? tab === 4
                          ? "#fff"
                          : "rgba(255, 255, 255, 0.6)"
                        : "inherit",
                    cursor: "pointer",
                  }}
                >
                  Closed
                </Link>
              </li>
            </ul>
          </div>

          {loading ? (
            <div className="text-center">
              <div className="spinner-border" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
              <p
                className="mt-2"
                style={{
                  color: isDarkMode ? "rgba(255, 255, 255, 0.6)" : "inherit",
                }}
              >
                Loading tasks...
              </p>
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-nowrap mb-0" style={tableStyle}>
                <thead>
                  <tr>
                    <th
                      style={{
                        color: isDarkMode
                          ? "rgba(255, 255, 255, 0.6)"
                          : "inherit",
                      }}
                    >
                      Topic
                    </th>
                    <th
                      style={{
                        color: isDarkMode
                          ? "rgba(255, 255, 255, 0.6)"
                          : "inherit",
                      }}
                    >
                      {isStudentView ? "Instructor" : "Student"}
                    </th>
                    <th
                      style={{
                        color: isDarkMode
                          ? "rgba(255, 255, 255, 0.6)"
                          : "inherit",
                      }}
                    >
                      Date
                    </th>
                    <th
                      style={{
                        color: isDarkMode
                          ? "rgba(255, 255, 255, 0.6)"
                          : "inherit",
                      }}
                    >
                      Status
                    </th>
                    <th
                      style={{
                        color: isDarkMode
                          ? "rgba(255, 255, 255, 0.6)"
                          : "inherit",
                      }}
                    >
                      Detail
                    </th>
                    {!isStudentView && (
                      <th
                        style={{
                          color: isDarkMode
                            ? "rgba(255, 255, 255, 0.6)"
                            : "inherit",
                        }}
                      >
                        Process
                      </th>
                    )}
                  </tr>
                </thead>
                <tbody>
                  {tasklist.length > 0 ? (
                    tasklist.map((data) => (
                      <Fragment key={data.id}>
                        <tr
                          style={{
                            backgroundColor: isDarkMode ? "#262932" : "#fff",
                          }}
                        >
                          <td
                            style={{
                              color: isDarkMode
                                ? "rgba(255, 255, 255, 0.6)"
                                : "inherit",
                            }}
                          >
                            {data.subject}
                          </td>
                          <td
                            style={{
                              color: isDarkMode
                                ? "rgba(255, 255, 255, 0.6)"
                                : "inherit",
                            }}
                          >
                            {isStudentView
                              ? data.instructorinfo
                              : data.studentinfo}
                          </td>
                          <td
                            style={{
                              color: isDarkMode
                                ? "rgba(255, 255, 255, 0.6)"
                                : "inherit",
                            }}
                          >
                            {data.setDate}
                          </td>
                          <td>
                            {isStudentView ? (
                              <>
                                {data.statusway === "Current" ? (
                                  <span className="badge bg-info">
                                    Agenda-1
                                  </span>
                                ) : data.statusway === "Later" ? (
                                  <span className="badge bg-warning">
                                    Agenda-2
                                  </span>
                                ) : data.statusway === "Closed" ? (
                                  <span className="badge bg-secondary">
                                    Closed
                                  </span>
                                ) : (
                                  ""
                                )}
                              </>
                            ) : (
                              <div className="select-container2 mx-2">
                                <select
                                  value={data.statusway || ""}
                                  onChange={(e) =>
                                    changeTaskStatus(data.id, e.target.value)
                                  }
                                  className="form-control"
                                  style={selectStyle(data.statusway)}
                                >
                                  <option value="Current">Agenda-1</option>
                                  <option value="Later">Agenda-2</option>
                                  <option value="Closed">Closed</option>
                                </select>
                              </div>
                            )}
                          </td>
                          <td>
                            <button
                              type="button"
                              className="btn btn-outline-info"
                              onClick={() => {
                                const target = document.getElementById(
                                  `collapseExample${data.id}`
                                );
                                if (target) {
                                  target.classList.toggle("show");
                                }
                              }}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="16"
                                height="16"
                                fill="currentColor"
                                className="bi bi-chevron-double-down"
                                viewBox="0 0 16 16"
                              >
                                <path
                                  fillRule="evenodd"
                                  d="M1.646 6.646a.5.5 0 0 1 .708 0L8 12.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                />
                                <path
                                  fillRule="evenodd"
                                  d="M1.646 2.646a.5.5 0 0 1 .708 0L8 8.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708"
                                />
                              </svg>
                            </button>
                          </td>
                          {!isStudentView && (
                            <td>
                              <div className="d-flex gap-2">
                                <button
                                  className="btn btn-success btn-sm"
                                  onClick={() => handleEdit(data)}
                                >
                                  <i className="fa fa-edit me-1"></i>
                                </button>
                                <button
                                  className="btn btn-danger btn-sm"
                                  onClick={() => handleDelete(data.id)}
                                >
                                  <i className="fa fa-trash"></i>
                                </button>
                              </div>
                            </td>
                          )}
                        </tr>
                        <tr
                          className={`collapse ${
                            collapseOpenClose ? "show" : ""
                          }`}
                          id={`collapseExample${data.id}`}
                        >
                          <td
                            colSpan={isStudentView ? 5 : 6}
                            style={{
                              backgroundColor: isDarkMode ? "#262932" : "#fff",
                            }}
                          >
                            <div
                              className="p-3"
                              style={{
                                color: isDarkMode
                                  ? "rgba(255, 255, 255, 0.6)"
                                  : "inherit",
                              }}
                            >
                              {isStudentView ? (
                                <div
                                  className="rounded p-3 border"
                                  style={{
                                    backgroundColor: isDarkMode
                                      ? "#1d1e26"
                                      : "#f8f9fa",
                                    color: isDarkMode
                                      ? "rgba(255, 255, 255, 0.6)"
                                      : "inherit",
                                  }}
                                >
                                  {data.desc
                                    ? parse(data.desc)
                                    : "No description available"}
                                </div>
                              ) : (
                                <TaskEdit
                                  value={data.desc}
                                  setValue={setNewAnswer}
                                  id={data.id}
                                  setStatus={setUpdated}
                                  status={updated}
                                  setUpdatedId={setUpdatedId}
                                  isDarkMode={isDarkMode}
                                />
                              )}
                            </div>
                          </td>
                        </tr>
                      </Fragment>
                    ))
                  ) : (
                    <tr>
                      <td
                        colSpan={isStudentView ? 5 : 6}
                        className="text-center"
                        style={{
                          color: isDarkMode
                            ? "rgba(255, 255, 255, 0.6)"
                            : "inherit",
                        }}
                      >
                        No tasks found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          )}
          <AgendaTaskModal
            isOpen={isModalOpen}
            toggle={toggleModal}
            studentId={slug}
            taskToEdit={editingTask}
            onSave={getStudentData}
            isDarkMode={isDarkMode}
          />
        <ConfirmModal
          isOpen={showConfirmModal}
          toggle={() => setShowConfirmModal(false)}
          onConfirm={confirmDelete}
          title="Delete Task"
          message="Are you sure you want to delete this task? This action cannot be undone."
        />
      </div>
    </div>
    {*/}
  </div>
  );
};

export { Tasks };
